import { inject, Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ICtaForm } from '@campaign-form/campaign-form.interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DeliverableStepService {
  private readonly translate = inject(TranslateService);

  public getExactMatchForCta(
    ctaForm: FormGroup<ICtaForm>,
    ctasValues: FormGroup<ICtaForm>['value'][],
  ): FormGroup<ICtaForm>['value'] | undefined {
    const value = ctaForm?.controls?.name?.value ?? '';

    if (!value) {
      return undefined;
    }

    return ctasValues.find((o) => o.name === value && o.id !== ctaForm?.controls?.id?.value);
  }

  public setExactMatchError(ctaForm: FormGroup<ICtaForm>, exactMatch: FormGroup<ICtaForm>['value'] | undefined): void {
    if (exactMatch) {
      ctaForm?.controls.name?.setErrors({ ctaNameAlreadyExists: true });
    } else {
      ctaForm?.controls.name?.setErrors(null);
    }
  }

  public ensureCtaNameIsUnique(ctaForm: FormGroup<ICtaForm>, ctasValues: FormGroup<ICtaForm>['value'][]): void {
    let ctaName = ctaForm?.controls?.name?.value ?? '';
    let exactMatch: FormGroup<ICtaForm>['value'] | undefined = this.getExactMatchForCta(ctaForm, ctasValues);

    while (exactMatch) {
      ctaName = `${ctaName} ${this.translate.instant('pages.campaignForm.sections.creatorsAndCtas.deliverableFlow.deliverableStep.copy')}`;
      ctaForm?.controls.name?.setValue(ctaName, { emitEvent: false });
      exactMatch = this.getExactMatchForCta(ctaForm, ctasValues);
    }

    ctaForm?.controls.name?.setValue(ctaName);
  }
}
